<template>
  <DpplHeaderFooterContent class="right-sidebar">
    <template #header>
      <div class="px-6 py-4 border-b-sm">
        <h2 class="text-h2">
          {{ tabTitle }}
        </h2>
      </div>
    </template>

    <div
      v-if="currentTab === 'template-usage'"
      class="w-100"
    >
      <TemplateUsage />
    </div>

    <div
      v-if="currentTab === 'history'"
      class="w-100"
    >
      <RevisionsContainer />
    </div>

    <CommentsSidebar
      v-if="currentTab === 'comments'"
      :page-id="jobProfile?.ulid"
      :page-name="route?.name"
      :page-title="jobProfile?.title"
    />
  </DpplHeaderFooterContent>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppRoute } from '@/stores/app/route';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';
import CommentsSidebar from '@/components/document/comments/CommentsSidebar.vue';
import DpplHeaderFooterContent from '@ui/components/general/DpplHeaderFooterContent/DpplHeaderFooterContent.vue';
import RevisionsContainer from './RevisionsContainer.vue';
import TemplateUsage from './TemplateUsage.vue';

const { route } = storeToRefs(useAppRoute());
const { jobProfile, isHrisProfile } = storeToRefs(useCurrentJobProfile());
const rightPanelStore = useDocumentRightPanel();
const { currentTab } = storeToRefs(rightPanelStore);

const tabTitle = computed(() => ({
  history: isHrisProfile.value ? 'Version history' : 'Revision history',
  'template-usage': 'Template used by',
}[currentTab.value] ?? 'Comments'));
</script>
